import React, { Fragment } from 'react';
import { View } from 'react-native';
import { styled, useBreakpointIndex } from 'dripsy';

import { MainNewsList } from './components/MainNewsList';
import { SideChatsList } from './components/SideChatsList';
import { Separator } from '@components';
import { IS_WEB } from '@utils';

const Container = styled(View)({
  flex: 1,
  bg: '$background0',
});

const ContentContainer = styled(View)({
  flex: 1,
  flexDirection: 'row',
  mx: [null, '5%'],
});

const NewsListContainer = styled(View)({
  flex: 3,
});

const ChatsListContainer = styled(View)({
  flex: 1,
});

export function NewsScreen() {
  const bIndex = useBreakpointIndex();

  return (
    <Container>
      <ContentContainer>
        <NewsListContainer>
          <MainNewsList />
        </NewsListContainer>
        {bIndex > 0 && IS_WEB && (
          <Fragment>
            <Separator size="$8" vertical />
            <ChatsListContainer>
              <SideChatsList />
            </ChatsListContainer>
          </Fragment>
        )}
      </ContentContainer>
    </Container>
  );
}
